import { ValidatedConciergeTreatmentSchema } from "@redotech/redo-model/ab-tests/concierge";
import { object, string } from "zod";

export const getConciergeTreatment = {
  input: object({ desiredTreatmentId: string().optional() }),
  output: object({
    conciergeTreatment: ValidatedConciergeTreatmentSchema.optional(),
  }),
};
